import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // get costs and expenses
    getCostsAndExpenses: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/dashboards/costs-and-expenses"
      return apiUtils.get(path)
    },
    // get incomes
    getIncomes: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/dashboards/incomes"
      return apiUtils.get(path)
    },
    // get cash flow
    getCashFlow: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/dashboards/cash-flow"
      return apiUtils.get(path)
    }
  }
}
